export const articlesPlatform = [
  {
    slug: 'mt4-guide',
    category: 'MT4 / MT5',
    categorySlug: 'mt4-mt5',
    title: 'คู่มือใช้งาน MT4 สำหรับมือใหม่ ครบทุกขั้นตอน',
    description:
      'คู่มือ MetaTrader 4 ตั้งแต่การติดตั้ง การเปิดกราฟ การเพิ่มคู่เงิน การเปิดออเดอร์ ไปจนถึงการตั้ง Stop Loss และ Take Profit',
    readingTime: '11 นาที',
    updatedDate: '2026-09-21',
    level: 'เริ่มเทรด',
    heroImage:
      'https://readdy.ai/api/search-image?query=Abstract%20minimal%20trading%20platform%20interface%20teal%20candlestick%20chart%20panels%20warm%20orange%20accent%20on%20light%20clean%20background%20editorial%20flat%20ui%20mockup%20no%20text%20no%20people&width=1200&height=675&seq=art-mt4-guide-01&orientation=landscape',
    tags: ['MT4', 'MetaTrader 4', 'คู่มือ'],
    intro: [
      'MetaTrader 4 หรือ MT4 เป็นแพลตฟอร์มเทรดที่ได้รับความนิยมมากที่สุดในกลุ่มเทรดเดอร์ Forex ด้วยหน้าตาการใช้งานที่เรียบง่ายและน้ำหนักเบา',
      'บทความนี้จะพามือใหม่ทำความรู้จักและใช้งาน MT4 ตั้งแต่ติดตั้งจนเปิดออเดอร์แรก',
    ],
    sections: [
      {
        id: 'install-open',
        heading: 'ติดตั้งและเปิดแพลตฟอร์ม',
        paragraphs: [
          'ดาวน์โหลด MT4 จากเว็บไซต์โบรกเกอร์ที่คุณใช้บริการ ติดตั้งบนคอมพิวเตอร์หรือมือถือ แล้วล็อกอินด้วยบัญชีที่สมัครไว้',
        ],
        bullets: [],
        steps: [
          {
            title: 'ขั้นตอนที่ 1 ติดตั้ง MT4',
            description: 'ดาวน์โหลดตัวติดตั้งและเปิดแพลตฟอร์มครั้งแรก เลือกเซิร์ฟเวอร์ของโบรกเกอร์ให้ถูกต้อง',
            image:
              'https://readdy.ai/api/search-image?query=Abstract%20minimal%20trading%20platform%20login%20window%20teal%20fields%20warm%20orange%20button%20on%20light%20background%20editorial%20flat%20ui%20mockup%20no%20text%20no%20people&width=900&height=560&seq=mt4-step-install-01&orientation=landscape',
          },
          {
            title: 'ขั้นตอนที่ 2 เปิดกราฟ',
            description: 'ดับเบิลคลิกคู่เงินใน Market Watch เพื่อเปิดหน้าต่างกราฟ แนะนำให้เลือกแท่งเทียนในมุมมอง Candlestick',
            image:
              'https://readdy.ai/api/search-image?query=Abstract%20minimal%20candlestick%20chart%20window%20teal%20growing%20candles%20warm%20orange%20trend%20line%20light%20background%20editorial%20flat%20ui%20mockup%20no%20text&width=900&height=560&seq=mt4-step-chart-01&orientation=landscape',
          },
          {
            title: 'ขั้นตอนที่ 3 เพิ่มคู่เงิน',
            description: 'คลิกขวาที่ Market Watch เลือก Symbols เพื่อเพิ่มคู่เงินที่ต้องการติดตามในรายการ',
            image:
              'https://readdy.ai/api/search-image?query=Abstract%20minimal%20symbol%20list%20panel%20teal%20rows%20warm%20orange%20checkboxes%20on%20light%20background%20editorial%20flat%20ui%20mockup%20no%20text%20no%20people&width=900&height=560&seq=mt4-step-symbols-01&orientation=landscape',
          },
          {
            title: 'ขั้นตอนที่ 4 เปิดออเดอร์',
            description: 'กด New Order เลือกทิศทาง Buy หรือ Sell กำหนด Volume แล้วยืนยันคำสั่ง',
            image:
              'https://readdy.ai/api/search-image?query=Abstract%20minimal%20new%20order%20ticket%20teal%20fields%20warm%20orange%20buy%20sell%20buttons%20on%20light%20background%20editorial%20flat%20ui%20mockup%20no%20text&width=900&height=560&seq=mt4-step-order-01&orientation=landscape',
          },
          {
            title: 'ขั้นตอนที่ 5 ตั้ง Stop Loss และ Take Profit',
            description: 'กรอกค่า Stop Loss และ Take Profit ในหน้าต่างคำสั่ง เพื่อจำกัดความเสี่ยงและล็อกกำไร',
            image:
              'https://readdy.ai/api/search-image?query=Abstract%20minimal%20order%20ticket%20with%20stop%20loss%20and%20take%20profit%20fields%20teal%20warm%20orange%20labels%20light%20background%20editorial%20flat%20ui%20no%20text&width=900&height=560&seq=mt4-step-sltp-01&orientation=landscape',
          },
        ],
      },
      {
        id: 'tips',
        heading: 'เคล็ดลับใช้งาน MT4',
        paragraphs: [
          'ปรับกรอบเวลาให้เหมาะกับสไตล์การเทรด ใช้เทมเพลตกราฟบันทึกการตั้งค่า และทดลองบนบัญชีทดลองก่อนเสมอ',
        ],
        bullets: [
          'บันทึก Template กราฟไว้ใช้ซ้ำได้',
          'ใช้บัญชีทดลองเพื่อทำความคุ้นเคยกับปุ่มต่าง ๆ',
          'ตรวจสอบ Spread ก่อนเปิดออเดอร์ทุกครั้ง',
        ],
        steps: [],
      },
    ],
    faqs: [
      {
        q: 'MT4 ใช้บนมือถือได้ไหม',
        a: 'ได้ MetaTrader 4 มีแอปสำหรับ iOS และ Android ที่รองรับการเปิดออเดอร์และตั้ง Stop Loss ได้ครบ',
        a2: 'แต่สิ่งที่ทำบนมือถือไม่ได้คือการติดตั้งอินดิเคเตอร์แบบกำหนดเองและการรัน Expert Advisor ขนาดหน้าจอยังเล็กจนอ่านกราฟ H1 ย้อนหลัง 200 แท่งได้ไม่สะดวก จึงควรใช้มือถือเฉพาะตรวจสถานะและปิดออเดอร์ ส่วนการวิเคราะห์ให้ทำบนคอมพิวเตอร์',
      },
      {
        q: 'MT4 กับ MT5 ต่างกันอย่างไร',
        a: 'MT5 เป็นรุ่นใหม่ที่รองรับสินทรัพย์หลากหลายและมีเครื่องมือวิเคราะห์มากขึ้น ส่วน MT4 ยังนิยมใช้ในกลุ่มเทรดเดอร์ Forex',
        a2: 'ตัวเลขที่ต่างชัดคือ MT4 มี 9 กรอบเวลา 30 อินดิเคเตอร์ในตัว และ 6 ประเภทคำสั่ง ส่วน MT5 มี 21 กรอบเวลา 38 อินดิเคเตอร์ และ 8 ประเภทคำสั่ง พร้อมรองรับหุ้นและฟิวเจอร์ส ถ้าเทรดเฉพาะ Forex ด้วยอินดิเคเตอร์พื้นฐาน MT4 ก็ยังเพียงพอ',
      },
    ],
    related: ['mt5-guide', 'how-to-check-spread-mt4', 'how-to-place-order'],
  },
  {
    slug: 'mt5-guide',
    category: 'MT4 / MT5',
    categorySlug: 'mt4-mt5',
    title: 'คู่มือใช้งาน MT5 สำหรับมือใหม่ ครบทุกขั้นตอน',
    description:
      'คู่มือ MetaTrader 5 ตั้งแต่การติดตั้ง การเปิดกราฟ การเพิ่มคู่เงิน การเปิดออเดอร์ ไปจนถึงการตั้ง Stop Loss และ Take Profit',
    readingTime: '11 นาที',
    updatedDate: '2026-09-21',
    level: 'เริ่มเทรด',
    heroImage:
      'https://readdy.ai/api/search-image?query=Abstract%20minimal%20modern%20trading%20platform%20interface%20teal%20chart%20panels%20warm%20orange%20indicator%20lines%20on%20light%20clean%20background%20editorial%20flat%20ui%20mockup%20no%20text%20no%20people&width=1200&height=675&seq=art-mt5-guide-01&orientation=landscape',
    tags: ['MT5', 'MetaTrader 5', 'คู่มือ'],
    intro: [
      'MetaTrader 5 หรือ MT5 คือแพลตฟอร์มรุ่นใหม่ที่ต่อยอดจาก MT4 พร้อมเครื่องมือวิเคราะห์และกรอบเวลาที่หลากหลายขึ้น',
      'บทความนี้จะพามือใหม่ทำความรู้จักและใช้งาน MT5 ตั้งแต่ติดตั้งจนเปิดออเดอร์',
    ],
    sections: [
      {
        id: 'install-open',
        heading: 'ติดตั้งและเปิดแพลตฟอร์ม',
        paragraphs: [
          'ดาวน์โหลด MT5 จากโบรกเกอร์ที่คุณใช้บริการ ติดตั้งและล็อกอินด้วยบัญชีที่สมัครไว้ หน้าตาจะคล้าย MT4 แต่มีเมนูเพิ่มเติม',
        ],
        bullets: [],
        steps: [
          {
            title: 'ขั้นตอนที่ 1 ติดตั้ง MT5',
            description: 'ติดตั้งแพลตฟอร์มและเลือกเซิร์ฟเวอร์ของโบรกเกอร์ให้ถูกต้อง แล้วล็อกอินเข้าสู่ระบบ',
            image:
              'https://readdy.ai/api/search-image?query=Abstract%20minimal%20trading%20platform%20login%20window%20teal%20fields%20warm%20orange%20button%20on%20light%20background%20editorial%20flat%20ui%20mockup%20no%20text%20no%20people&width=900&height=560&seq=mt5-step-install-01&orientation=landscape',
          },
          {
            title: 'ขั้นตอนที่ 2 เปิดกราฟ',
            description: 'เปิดกราฟคู่เงินจาก Market Watch ปรับกรอบเวลาและรูปแบบแท่งเทียนตามต้องการ',
            image:
              'https://readdy.ai/api/search-image?query=Abstract%20minimal%20candlestick%20chart%20window%20teal%20candles%20warm%20orange%20moving%20average%20line%20light%20background%20editorial%20flat%20ui%20mockup%20no%20text&width=900&height=560&seq=mt5-step-chart-01&orientation=landscape',
          },
          {
            title: 'ขั้นตอนที่ 3 เพิ่มคู่เงิน',
            description: 'ใช้หน้าต่าง Symbols เพื่อค้นหาและเพิ่มคู่เงินที่ต้องการติดตาม',
            image:
              'https://readdy.ai/api/search-image?query=Abstract%20minimal%20symbol%20search%20panel%20teal%20rows%20warm%20orange%20star%20markers%20on%20light%20background%20editorial%20flat%20ui%20mockup%20no%20text%20no%20people&width=900&height=560&seq=mt5-step-symbols-01&orientation=landscape',
          },
          {
            title: 'ขั้นตอนที่ 4 เปิดออเดอร์',
            description: 'กด New Order เลือกทิศทางและกำหนด Volume แล้วยืนยันคำสั่งซื้อขาย',
            image:
              'https://readdy.ai/api/search-image?query=Abstract%20minimal%20new%20order%20panel%20teal%20fields%20warm%20orange%20confirmation%20button%20on%20light%20background%20editorial%20flat%20ui%20mockup%20no%20text&width=900&height=560&seq=mt5-step-order-01&orientation=landscape',
          },
          {
            title: 'ขั้นตอนที่ 5 ตั้ง Stop Loss และ Take Profit',
            description: 'กำหนดจุดตัดขาดทุนและทำกำไรในหน้าต่างคำสั่งก่อนยืนยัน',
            image:
              'https://readdy.ai/api/search-image?query=Abstract%20minimal%20order%20panel%20with%20stop%20loss%20and%20take%20profit%20fields%20teal%20warm%20orange%20labels%20light%20background%20editorial%20flat%20ui%20no%20text&width=900&height=560&seq=mt5-step-sltp-01&orientation=landscape',
          },
        ],
      },
      {
        id: 'extras',
        heading: 'จุดเด่นของ MT5',
        paragraphs: [
          'MT5 มีกรอบเวลามากขึ้น มีอินดิเคเตอร์และออบเจกต์วิเคราะห์ให้เลือกใช้เยอะกว่า และรองรับสินทรัพย์หลากหลายกว่า MT4',
        ],
        bullets: [
          'กรอบเวลาย่อยละเอียดขึ้น',
          'มีเครื่องมือวิเคราะห์ในตัวมากขึ้น',
          'รองรับการทดสอบกลยุทธ์ย้อนหลัง',
        ],
        steps: [],
      },
    ],
    faqs: [
      {
        q: 'MT5 เปิดออเดอร์เหมือน MT4 ไหม',
        a: 'ขั้นตอนคล้ายกัน แต่ MT5 แยกหน้าต่างจัดการออเดอร์ชัดเจนกว่าเล็กน้อย',
        a2: 'ความต่างที่สัมผัสได้จริงคือ MT5 มีหน้าต่าง New Order ที่รวมขนาดสถานะ จุด Stop Loss และ Take Profit ไว้ในหน้าเดียว และแสดงระยะเป็น Point ให้อัตโนมัติ ส่วน MT4 ต้องแปลง Pip เองก่อนกรอก ซึ่งเป็นจุดที่มือใหม่กรอกผิดบ่อยที่สุด',
      },
      {
        q: 'ควรเริ่มเรียน MT4 หรือ MT5 ก่อน',
        a: 'ทั้งสองใช้หลักการเดียวกัน เรียน MT4 ก่อนจะเข้าใจง่ายและต่อยอดไป MT5 ได้เร็ว',
        a2: 'ถ้าเลือกโบรกเกอร์ที่ให้ทั้งสองแพลตฟอร์ม ให้เริ่มด้วย MT4 ประมาณ 2-4 สัปดาห์จนตั้ง Stop Loss และคำนวณ Lot ได้คล่อง แล้วจึงย้ายไป MT5 การเรียนสองแพลตฟอร์มพร้อมกันมักทำให้สับสนเรื่องหน่วย Point กับ Pip',
      },
    ],
    related: ['mt4-guide', 'how-to-place-order-mt5', 'how-to-place-order'],
  },
  {
    slug: 'mt4-vs-mt5',
    category: 'MT4 / MT5',
    categorySlug: 'mt4-mt5',
    title: 'MT4 กับ MT5 ต่างกันอย่างไร เปรียบเทียบครบทุกจุด',
    description:
      'เปรียบเทียบ MT4 กับ MT5 เรื่องประเภทคำสั่ง Timeframe จำนวนอินดิเคเตอร์ และสินทรัพย์ที่รองรับ พร้อมตารางเทียบให้เห็นชัด และคำแนะนำว่ามือใหม่ควรเริ่มจากตัวไหน',
    readingTime: '8 นาที',
    updatedDate: '2026-10-20',
    level: 'เริ่มเทรด',
    heroImage:
      'https://readdy.ai/api/search-image?query=Two%20laptops%20side%20by%20side%20on%20a%20light%20warm%20wooden%20desk%2C%20left%20screen%20showing%20a%20single%20simple%20teal%20candlestick%20chart%2C%20right%20screen%20showing%20several%20small%20chart%20panels%20with%20warm%20orange%20indicator%20lines%2C%20a%20thin%20divider%20between%20the%20two%20laptops%2C%20minimal%20editorial%20fintech%20style%2C%20soft%20natural%20light%2C%20no%20text%2C%20no%20people%2C%20no%20logos&width=1200&height=675&seq=art-mt4-vs-mt5-01&orientation=landscape',
    tags: ['MT4', 'MT5', 'เปรียบเทียบ', 'MetaTrader'],
    intro: [
      'หลายคนที่เพิ่งเปิดบัญชีเจอคำถามเดียวกันว่า ควรโหลด MT4 หรือ MT5 ดี เพราะสองแพลตฟอร์มหน้าตาคล้ายกันมาก จนแยกไม่ออกว่าต่างกันตรงไหน',
      'บทความนี้สรุปความต่างที่มีผลกับการเทรดจริงไว้เป็นตาราง พร้อมอธิบายว่าความต่างแต่ละข้อหมายความว่าอะไรสำหรับมือใหม่',
    ],
    sections: [
      {
        id: 'comparison-table',
        heading: 'ตารางเปรียบเทียบ MT4 กับ MT5',
        paragraphs: [
          'ตารางด้านล่างเทียบเฉพาะหัวข้อที่มีผลต่อการตัดสินใจใช้งานจริง ไม่ใช่การเทียบว่าตัวไหนดีกว่า เพราะทั้งสองตัวยังใช้งานหลักคือดูกราฟและเปิดออเดอร์เหมือนกัน',
        ],
        table: {
          columns: ['หัวข้อ', 'MT4', 'MT5'],
          rows: [
            ['ปีที่เปิดตัว', '2005 โดย MetaQuotes', '2010 โดย MetaQuotes'],
            [
              'ประเภทคำสั่ง',
              'Market Buy / Sell + Pending 4 แบบ (Buy Limit, Sell Limit, Buy Stop, Sell Stop) รวม 6 แบบ',
              'Market Buy / Sell + Pending 6 แบบ (เพิ่ม Buy Stop Limit และ Sell Stop Limit) รวม 8 แบบ',
            ],
            [
              'Timeframe',
              '9 กรอบ: M1 M5 M15 M30 H1 H4 D1 W1 MN1',
              '21 กรอบ: เพิ่ม M2 M3 M4 M6 M10 M12 M20 H2 H3 H6 H8 H12 เข้ามา',
            ],
            ['อินดิเคเตอร์ในตัว', '30 ตัว', '38 ตัว'],
            [
              'สินทรัพย์ที่เทรดได้',
              'เน้น Forex และ CFD เป็นหลัก',
              'Forex, หุ้น, ฟิวเจอร์ส, ออปชัน, พันธบัตร และ CFD ในบัญชีเดียว',
            ],
            ['รูปแบบบัญชี', 'รองรับ Hedging อย่างเดียว', 'เลือกได้ทั้ง Netting และ Hedging'],
            [
              'ทดสอบย้อนหลัง',
              'ทีละคู่เงิน ทีละช่วงเวลา',
              'หลายคู่เงินพร้อมกัน พร้อมข้อมูล Tick จริงและทดสอบแบบหลายคอร์',
            ],
            ['ปฏิทินเศรษฐกิจ', 'ไม่มีในตัว ต้องเปิดเว็บภายนอก', 'มีมาให้ในแพลตฟอร์ม'],
          ],
        },
        bullets: [],
        steps: [],
      },
      {
        id: 'what-matters',
        heading: 'ความต่างที่กระทบการเทรดจริง',
        paragraphs: [
          'ตัวเลขในตารางอาจดูเป็นเรื่องเทคนิค แต่มีอยู่ 4 ข้อที่มือใหม่จะรู้สึกได้ทันทีตอนใช้งานจริง',
        ],
        bullets: [
          'คำสั่ง Buy Stop Limit กับ Sell Stop Limit ใน MT5 ใช้เมื่ออยากให้ราคาแตะระดับหนึ่งก่อน แล้วค่อยเข้าออเดอร์เมื่อราคากลับตัว ถ้าเทรดด้วย MT4 จะต้องเฝ้าหน้าจอเองหรือรอจังหวะใหม่',
          'กรอบเวลา M2 ถึง M12 ใน MT5 ทำให้กำหนดจังหวะเข้าได้ละเอียดขึ้น แต่กราฟก็จะผันผวนถี่ขึ้นตามไปด้วย มือใหม่มักตื่นเต้นกับการเห็นแท่งเทียนเยอะขึ้นจนเปิดออเดอร์บ่อยเกินแผน',
          'อินดิเคเตอร์ 38 ตัวของ MT5 ไม่ได้ทำให้วิเคราะห์เก่งขึ้นอัตโนมัติ การเข้าใจอินดิเคเตอร์ 2 ถึง 3 ตัวให้ลึกยังมีค่ามากกว่าการติดตั้งสิบตัวพร้อมกัน',
          'ถ้าอยากเทรดหุ้นหรือฟิวเจอร์สในบัญชีเดียวกัน MT5 เป็นตัวเลือกเดียว เพราะ MT4 เน้น Forex กับ CFD และไม่รองรับตลาดซื้อขายหลักทรัพย์',
          'บัญชีแบบ Netting ใน MT5 จะรวมออเดอร์ทิศเดียวกันเป็นสถานะเดียว ทำให้อ่านความเสี่ยงรวมง่ายขึ้น ต่างจาก MT4 ที่ถือแยกได้ทุกออเดอร์จนบางทีลืมว่ามีสถานะอะไรค้างอยู่',
        ],
        steps: [],
      },
      {
        id: 'which-to-choose',
        heading: 'แล้วมือใหม่ควรเลือกตัวไหน',
        paragraphs: [
          'ไม่มีคำตอบเดียวสำหรับทุกคน คำตอบขึ้นอยู่กับโบรกเกอร์ที่ใช้และสิ่งที่อยากทำมากกว่าอยากเทรดแค่คู่เงินหลัก',
          'ถ้ายังไม่แน่ใจ ให้เริ่มจากแพลตฟอร์มที่โบรกเกอร์หลักของคุณรองรับเต็มรูปแบบก่อน แล้วค่อยติดตั้งอีกตัวเมื่อจำเป็นจริง ๆ เพราะการสลับไปมาบ่อย ๆ ทำให้จำตำแหน่งเมนูไม่ได้',
        ],
        bullets: [
          'เพิ่งเริ่มและโบรกเกอร์ให้ MT4 มา ใช้ MT4 ต่อได้เลย คู่มือและคลิปสอนมีเยอะกว่า และเพียงพอสำหรับการเทรด Forex',
          'อยากเทรดหลายสินทรัพย์หรือจริงจังกับการทดสอบกลยุทธ์ย้อนหลัง เลือก MT5 คุ้มกว่าในระยะยาว',
          'ทั้งสองแพลตฟอร์มดู Spread ได้เหมือนกัน ต่างกันแค่ตำแหน่งเมนู จึงย้ายไปมาได้โดยไม่ต้องเรียนใหม่ทั้งหมด',
          'ไม่ต้องติดตั้งพร้อมกันทั้งสองตัว ถ้ายังไม่มั่นใจ ให้เลือกตัวเดียวแล้วฝึกเปิดปิดออเดอร์ให้คล่องก่อน',
        ],
        steps: [],
      },
    ],
    faqs: [
      {
        q: 'MT4 กับ MT5 ต่างกันมากไหม',
        a: 'หลักการเทรดเหมือนกัน ทั้งคู่ใช้ดูกราฟและเปิดออเดอร์ ความต่างหลักอยู่ที่จำนวนประเภทคำสั่ง กรอบเวลา อินดิเคเตอร์ และสินทรัพย์ที่รองรับ ซึ่งส่งผลเฉพาะเมื่อคุณต้องการใช้ความสามารถเหล่านั้น',
        a2: 'ตัวเลขที่ควรรู้คือ MT4 มี 9 กรอบเวลา 30 อินดิเคเตอร์ 6 ประเภทคำสั่ง และเทรดได้เฉพาะ Forex กับโลหะ ส่วน MT5 มี 21 กรอบเวลา 38 อินดิเคเตอร์ 8 ประเภทคำสั่ง และรองรับหุ้น ดัชนี ฟิวเจอร์ส ความต่างจะสำคัญก็ต่อเมื่อคุณต้องการใช้ความสามารถเหล่านั้นจริง',
      },
      {
        q: 'อินดิเคเตอร์ที่ใช้อยู่บน MT4 ย้ายไป MT5 ได้ไหม',
        a: 'ไม่ได้โดยตรง เพราะสองแพลตฟอร์มใช้ภาษาเขียนโปรแกรมคนละตัว ต้องหาอินดิเคเตอร์เวอร์ชัน MT5 หรือเขียนใหม่ แต่หลักการอ่านค่ายังเหมือนเดิม',
        a2: 'ถ้าต้องการย้ายจริงมีสองทาง คือหาอินดิเคเตอร์เวอร์ชัน MT5 จากผู้พัฒนาเดียวกัน หรือเขียนใหม่ด้วย MQL5 ซึ่งใช้เวลาเรียนรู้ราว 2-4 สัปดาห์สำหรับคนที่มีพื้นฐานเขียนโปรแกรม แต่ถ้าอินดิเคเตอร์ที่ใช้มีแค่ 2-3 ตัว การเลือกใช้ของที่มากับ MT5 อาจเร็วกว่า',
      },
      {
        q: 'บัญชีเดียวใช้ได้ทั้ง MT4 และ MT5 หรือเปล่า',
        a: 'โดยทั่วไปโบรกเกอร์แยกบัญชีสำหรับแต่ละแพลตฟอร์ม ควรสอบถามโบรกเกอร์ก่อน เพราะบางแห่งให้ล็อกอินเดียวกันได้ แต่บางแห่งต้องเปิดบัญชีใหม่',
        a2: 'สิ่งที่ควรถามให้ชัดคือ เลขบัญชีเดียวกันหรือไม่ รหัสผ่านชุดเดียวหรือไม่ และประวัติการเทรดบน MT4 ยังดูได้หลังย้ายไป MT5 ไหม เพราะบางแห่งปิดประวัติเดิมเมื่อเปิดบัญชีใหม่ ทำให้ย้อนดูผลลัพธ์เก่าไม่ได้',
      },
    ],
    related: ['mt4-guide', 'mt5-guide', 'how-to-place-order-mt5'],
  },
  {
    slug: 'how-to-check-spread-mt4',
    category: 'MT4 / MT5',
    categorySlug: 'mt4-mt5',
    title: 'วิธีดู Spread บน MT4 ก่อนเปิดออเดอร์',
    description:
      'สอนวิธีดูค่า Spread บนแพลตฟอร์ม MT4 ทั้งผ่าน Market Watch และกราฟ เพื่อประเมินต้นทุนก่อนเทรด',
    readingTime: '7 นาที',
    updatedDate: '2026-09-20',
    level: 'เริ่มเทรด',
    heroImage:
      'https://readdy.ai/api/search-image?query=Abstract%20minimal%20market%20watch%20panel%20showing%20bid%20ask%20spread%20teal%20rows%20warm%20orange%20highlight%20on%20light%20background%20editorial%20flat%20ui%20mockup%20no%20text%20no%20people&width=1200&height=675&seq=art-check-spread-mt4-01&orientation=landscape',
    tags: ['MT4', 'Spread', 'วิธีใช้'],
    intro: [
      'Spread บน MT4 เปลี่ยนตลอดเวลา การรู้วิธีดู Spread ช่วยให้รู้ต้นทุนก่อนเปิดออเดอร์และหลีกเลี่ยงช่วงที่ Spread กว้างผิดปกติ',
      'บทความนี้จะแสดงวิธีดู Spread ทั้งจาก Market Watch และกราฟ',
    ],
    sections: [
      {
        id: 'tutorial',
        heading: 'ขั้นตอนการดู Spread',
        paragraphs: [
          'ทำตามขั้นตอนด้านล่างเพื่อเปิดคอลัมน์ Spread และอ่านค่าได้อย่างถูกต้อง',
        ],
        bullets: [],
        steps: [
          {
            title: 'ขั้นตอนที่ 1 เปิด Market Watch',
            description: 'มุมมอง Market Watch จะแสดงคู่เงินที่ติดตาม และมีคอลัมน์ Bid / Ask',
            image:
              'https://readdy.ai/api/search-image?query=Abstract%20minimal%20market%20watch%20list%20teal%20bid%20ask%20columns%20warm%20orange%20accent%20light%20background%20editorial%20flat%20ui%20mockup%20no%20text&width=900&height=560&seq=spread-step-marketwatch-01&orientation=landscape',
          },
          {
            title: 'ขั้นตอนที่ 2 เปิดคอลัมน์ Spread',
            description: 'คลิกขวาที่หัวตาราง เลือก Spread เพื่อให้แสดงค่าความต่างระหว่าง Bid และ Ask',
            image:
              'https://readdy.ai/api/search-image?query=Abstract%20minimal%20context%20menu%20with%20spread%20option%20teal%20highlight%20warm%20orange%20check%20on%20light%20background%20editorial%20flat%20ui%20no%20text&width=900&height=560&seq=spread-step-column-01&orientation=landscape',
          },
          {
            title: 'ขั้นตอนที่ 3 อ่านค่า Spread',
            description: 'ค่าที่แสดงจะเป็น Spread ปัจจุบันในหน่วย Pip ยิ่งน้อยยิ่งมีต้นทุนต่ำ',
            image:
              'https://readdy.ai/api/search-image?query=Abstract%20minimal%20spread%20numbers%20in%20teal%20table%20with%20warm%20orange%20indicator%20on%20light%20background%20editorial%20flat%20fintech%20no%20text&width=900&height=560&seq=spread-step-read-01&orientation=landscape',
          },
        ],
      },
      {
        id: 'when-wide',
        heading: 'Spread กว้างตอนไหน',
        paragraphs: [
          'Spread มักกว้างขึ้นช่วงเปิดตลาด หลังข่าวเศรษฐกิจสำคัญ และช่วงที่สภาพคล่องต่ำ ควรหลีกเลี่ยงการเทรดในช่วงเวลาดังกล่าว',
          'ช่วงที่ควรระวังเป็นพิเศษคือ 5 นาทีก่อนและหลังข่าวอย่าง Non-Farm Payrolls หรือการประกาศดอกเบี้ย ซึ่ง Spread ของ EURUSD อาจกระโดดจาก 1 Pip ไปเป็น 8 ถึง 15 Pip ภายในไม่กี่วินาที เช่นเดียวกับช่วงเปิดตลาดวันจันทร์ที่สภาพคล่องยังบาง และช่วงใกล้เวลา Rollover ประมาณ 05:00 น. ตามเวลาเซิร์ฟเวอร์',
        ],
        bullets: [],
        steps: [],
      },
    ],
    faqs: [
      {
        q: 'Spread ที่ดีควรเป็นเท่าไหร่',
        a: 'สำหรับคู่เงินหลัก Spread ต่ำมักอยู่ที่ประมาณ 0.5 ถึง 1.5 Pip ส่วนคู่เงิน Exotic อาจสูงกว่า 3 Pip ขึ้นไป',
        a2: 'แต่ตัวเลขนี้ใช้ได้เฉพาะคู่เงินหลักอย่าง EURUSD หรือ GBPUSD ในช่วง London กับ New York ส่วนคู่เงิน Exotic อย่าง USDZAR หรือ USDTRY อาจกว้าง 20-50 Pip ในเวลาเดียวกัน และช่วงข่าวเศรษฐกิจสำคัญ Spread อาจพุ่งเป็น 3-5 เท่าภายในไม่กี่วินาที',
      },
      {
        q: 'ทำไม Spread เปลี่ยนบ่อย',
        a: 'เพราะ Spread สะท้อนสภาพคล่องของตลาด ซึ่งเปลี่ยนไปตามช่วงเวลาและข่าว จึงเป็นค่าระบบลอยตัว',
        a2: 'ช่วงที่กว้างที่สุดมักเป็น 5 นาทีก่อนและหลังข่าว Non-Farm Payrolls หรือการประกาศดอกเบี้ย ซึ่ง Spread อาจกระโดดจาก 1 Pip เป็น 10 Pip ในไม่กี่วินาที และช่วงเปิดตลาดวันจันทร์ที่สภาพคล่องยังบาง ถ้าจะเข้าไม้ช่วงนั้นควรลดขนาดสถานะลงครึ่งหนึ่ง',
      },
    ],
    related: ['what-is-spread', 'mt4-guide', 'how-to-trade-forex'],
  },
  {
    slug: 'how-to-check-spread-mt5',
    category: 'MT4 / MT5',
    categorySlug: 'mt4-mt5',
    title: 'วิธีดู Spread บน MT5 ก่อนเปิดออเดอร์',
    description:
      'สอนวิธีดูค่า Spread บน MT5 ตั้งแต่การเปิดคอลัมน์ Spread ใน Market Watch ไปจนถึงการเช็กตอนอยู่ในหน้าต่าง New Order พร้อมจุดที่ Spread มักกว้างจนไม่ควรเข้า',
    readingTime: '8 นาที',
    updatedDate: '2026-10-20',
    level: 'เริ่มเทรด',
    heroImage:
      'https://readdy.ai/api/search-image?query=Close%20up%20of%20a%20laptop%20screen%20showing%20a%20market%20watch%20table%20with%20two%20price%20columns%20and%20one%20highlighted%20row%2C%20a%20small%20wooden%20ruler%20lying%20across%20the%20gap%20between%20two%20price%20tags%20on%20a%20light%20warm%20desk%2C%20teal%20interface%20with%20warm%20orange%20highlight%2C%20minimal%20editorial%20fintech%20style%2C%20no%20text%2C%20no%20people%2C%20no%20logos&width=1200&height=675&seq=art-check-spread-mt5-01&orientation=landscape',
    tags: ['MT5', 'Spread', 'วิธีใช้'],
    intro: [
      'ค่า Spread บน MT5 ขยับตลอดเวลา และเป็นต้นทุนก้อนแรกที่ถูกหักทันทีที่เปิดออเดอร์ หลายคนดูกราฟจนชำนาญแต่ยังไม่เคยเปิดคอลัมน์นี้ดูเลย',
      'บทความนี้จะพาไปดูว่าใน MT5 มีจุดไหนบ้างที่อ่าน Spread ได้ และค่าแบบไหนที่ควรปล่อยผ่าน',
    ],
    sections: [
      {
        id: 'tutorial',
        heading: 'ขั้นตอนการดู Spread บน MT5',
        paragraphs: [
          'ทำตามลำดับด้านล่างทีละขั้น หลังเปิดคอลัมน์ Spread ครั้งแรกแล้ว MT5 จะจำค่าไว้ให้ใช้ต่อในครั้งหน้า',
        ],
        bullets: [],
        steps: [
          {
            title: 'ขั้นตอนที่ 1 เปิด Market Watch',
            description: 'มุมซ้ายบนของหน้าจอ MT5 จะมี Market Watch แสดงคู่เงินที่ติดตาม พร้อมคอลัมน์ Bid และ Ask',
            image:
              'https://readdy.ai/api/search-image?query=Minimal%20flat%20ui%20mockup%20of%20a%20market%20watch%20panel%20with%20teal%20currency%20rows%20and%20two%20price%20columns%20on%20a%20light%20warm%20background%20with%20a%20soft%20orange%20highlight%2C%20editorial%20fintech%20style%2C%20no%20text%2C%20no%20people&width=900&height=560&seq=mt5spread-step-marketwatch-01&orientation=landscape',
          },
          {
            title: 'ขั้นตอนที่ 2 เพิ่มคอลัมน์ Spread',
            description: 'คลิกขวาที่หัวตาราง Market Watch แล้วเลือก Spread จากเมนู คอลัมน์ใหม่จะโผล่ขึ้นมาทางขวา',
            image:
              'https://readdy.ai/api/search-image?query=Minimal%20flat%20ui%20mockup%20of%20a%20right%20click%20context%20menu%20with%20one%20option%20highlighted%20in%20warm%20orange%20next%20to%20a%20teal%20table%20header%20on%20a%20light%20warm%20background%2C%20editorial%20fintech%20style%2C%20no%20text%2C%20no%20people&width=900&height=560&seq=mt5spread-step-column-01&orientation=landscape',
          },
          {
            title: 'ขั้นตอนที่ 3 อ่านค่าและเทียบกับจุดที่เคยเทรด',
            description: 'ค่าที่แสดงคือส่วนต่างระหว่าง Bid กับ Ask ในหน่วย Point โดย 10 Point ของคู่เงินหลักเท่ากับ 1 Pip ให้เทียบกับค่าที่คุณเห็นในช่วงเวลาที่เคยเทรดปกติ',
            image:
              'https://readdy.ai/api/search-image?query=Minimal%20flat%20ui%20mockup%20of%20a%20spread%20value%20highlighted%20in%20a%20teal%20table%20row%20with%20a%20warm%20orange%20marker%20and%20a%20small%20magnifier%20on%20a%20light%20warm%20background%2C%20editorial%20fintech%20style%2C%20no%20text%2C%20no%20people&width=900&height=560&seq=mt5spread-step-read-01&orientation=landscape',
          },
        ],
      },
      {
        id: 'where-to-check',
        heading: 'ดู Spread ได้จากสามจุดใน MT5',
        paragraphs: [
          'MT5 แสดงค่า Spread ไว้หลายที่ แต่ละที่มีจุดประสงค์ต่างกัน เลือกดูให้ตรงกับจังหวะที่กำลังทำอยู่',
        ],
        table: {
          columns: ['จุดที่ดู', 'แสดงอะไร', 'เหมาะกับการใช้งานแบบไหน'],
          rows: [
            ['Market Watch', 'Spread ปัจจุบันของทุกคู่เงินที่ติดตามอยู่', 'เทียบหลายคู่เงินพร้อมกันก่อนตัดสินใจว่าจะเล่นตัวไหน'],
            ['หน้าต่าง New Order', 'Spread ของคู่เงินที่กำลังจะสั่ง พร้อมราคา Bid / Ask', 'เช็กต้นทุนจริงก่อนกดยืนยันทุกครั้ง'],
            ['Depth of Market (DOM)', 'ระดับราคา Bid / Ask พร้อมปริมาณในแต่ละระดับ', 'ดูว่าสภาพคล่องบางหรือหนา โดยเฉพาะก่อนข่าว'],
          ],
        },
        bullets: [],
        steps: [],
      },
      {
        id: 'calculator',
        heading: 'ลองคำนวณต้นทุนจาก Spread',
        paragraphs: [
          'ค่า Spread ที่เห็นอาจดูเป็นตัวเลขเล็ก ๆ แต่พอคูณกับจำนวนล็อตแล้วกลายเป็นเงินจริง ลองใส่ค่าที่เพิ่งอ่านเจอลงไป แล้วเทียบกับกำไรเป้าหมายของออเดอร์นั้น จะเห็นชัดว่าทำไมคู่เงินที่ Spread กว้างถึงต้องคิดหนักกว่าปกติ',
        ],
        widget: 'spread-cost',
        bullets: [],
        steps: [],
      },
      {
        id: 'when-wide',
        heading: 'Spread กว้างตอนไหนและควรทำอย่างไร',
        paragraphs: [
          'Spread ไม่ได้คงที่ตลอดวัน มันสะท้อนว่าตอนนั้นมีคนตั้งราคาซื้อขายมากแค่ไหน ยิ่งบาง ยิ่งกว้าง ซึ่งเป็นเรื่องปกติของตลาด ไม่ใช่ความผิดพลาดของแพลตฟอร์ม',
        ],
        bullets: [
          'ช่วงเปิดตลาดแต่ละรอบ Spread มักกระตุกกว้างขึ้นในไม่กี่วินาทีแรก รอให้ตลาดนิ่งขึ้นสักครู่แล้วค่อยกด',
          'ก่อนและหลังข่าวเศรษฐกิจสำคัญ Spread อาจกว้างกว่าปกติหลายเท่า ถ้าไม่ได้ตั้งใจเล่นข่าว ให้เลี่ยงช่วงนี้',
          'ช่วงปิดสัปดาห์และใกล้เวลา Rollover สภาพคล่องจะบางมาก เป็นช่วงที่ต้นทุนบวมที่สุด',
          'ถ้าเห็น Spread กระตุกกว้างผิดปกติทั้งที่ไม่มีข่าว ให้เช็กการเชื่อมต่อเซิร์ฟเวอร์ก่อน ไม่ใช่เพิ่งกดออเดอร์',
        ],
        steps: [],
      },
    ],
    faqs: [
      {
        q: 'Spread บน MT5 หน่วยเป็นอะไร',
        a: 'คอลัมน์ Spread ใน Market Watch แสดงเป็น Point ซึ่งคู่เงินหลักส่วนใหญ่ใช้ 10 Point = 1 Pip แต่คู่เงินที่ราคาทศนิยม 3 หลักอาจต่างออกไป ให้ดูจากหน้าต่าง Specification ของคู่นั้นประกอบ',
        a2: 'ตัวอย่างเช่น EURUSD ที่ราคา 1.08542 แสดง Spread 12 Point หมายถึง 1.2 Pip ถ้าเทรด 0.10 Lot ซึ่ง 1 Pip = 1 ดอลลาร์ ต้นทุน Spread ของไม้นั้นประมาณ 1.2 ดอลลาร์ และถ้าเปิด 10 ไม้ต่อวันก็คือ 12 ดอลลาร์ที่หายไปก่อนราคาจะขยับเลย',
      },
      {
        q: 'ทำไม Spread บน MT5 ต่างจากที่เห็นในเว็บโบรกเกอร์',
        a: 'เพราะค่าในเว็บมักเป็นค่าตัวอย่างหรือค่าเฉลี่ย ส่วนค่าในแพลตฟอร์มคือค่าจริง ณ วินาทีนั้น ให้ยึดค่าที่เห็นในหน้าต่าง New Order ก่อนกด',
        a2: 'ค่าเฉลี่ยบนเว็บมักคิดจากทั้งวัน จึงดูดีกว่าความจริงตอนที่คุณกดออเดอร์ วิธีตรวจที่ตรงที่สุดคือเปิดหน้าต่าง New Order แล้วดู Spread ที่แสดงคู่กับราคา Ask และ Bid ในวินาทีนั้น พร้อมเทียบกับค่าเฉลี่ยรายสัปดาห์ของโบรกเกอร์',
      },
      {
        q: 'ต้องเปิดคอลัมน์ Spread ใหม่ทุกรอบไหม',
        a: 'ไม่ต้อง MT5 จะจำการตั้งค่า Market Watch ไว้ให้ แต่ถ้าเปลี่ยนเครื่องหรือติดตั้งใหม่ ต้องเปิดคอลัมน์อีกครั้ง',
        a2: 'วิธีเปิดใหม่คือคลิกขวาที่ Market Watch เลือก Columns แล้วติ๊ก Spread ใช้เวลาไม่ถึง 10 วินาที และควรตรวจอีกครั้งทุกครั้งหลังอัปเดตแพลตฟอร์ม เพราะบางเวอร์ชันรีเซ็ตการตั้งค่ากลับเป็นค่าเริ่มต้น',
      },
    ],
    related: ['what-is-spread', 'how-to-check-spread-mt4', 'mt5-guide'],
  },
  {
    slug: 'how-to-place-order-mt5',
    category: 'MT4 / MT5',
    categorySlug: 'mt4-mt5',
    title: 'วิธีเปิดออเดอร์บน MT5 ทีละขั้นตอนสำหรับมือใหม่',
    description:
      'คู่มือเปิดออเดอร์บน MT5 ตั้งแต่เลือกคู่เงิน กำหนดขนาดล็อต ตั้ง Stop Loss ไปจนถึงยืนยันคำสั่งซื้อขาย',
    readingTime: '9 นาที',
    updatedDate: '2026-09-21',
    level: 'เริ่มเทรด',
    heroImage:
      'https://readdy.ai/api/search-image?query=Abstract%20minimal%20mt5%20new%20order%20panel%20teal%20fields%20warm%20orange%20buy%20sell%20buttons%20on%20light%20clean%20background%20editorial%20flat%20ui%20mockup%20no%20text%20no%20people&width=1200&height=675&seq=art-place-order-mt5-01&orientation=landscape',
    tags: ['MT5', 'เปิดออเดอร์', 'คู่มือ'],
    intro: [
      'การเปิดออเดอร์บน MT5 มีลำดับขั้นตอนชัดเจน เข้าใจง่าย หากตั้งค่าถูกต้องตั้งแต่แรกจะช่วยลดความผิดพลาดได้มาก',
      'บทความนี้จะพาไปดูทุกขั้นตอนของการเปิดออเดอร์บน MT5',
    ],
    sections: [
      {
        id: 'tutorial',
        heading: 'ขั้นตอนการเปิดออเดอร์บน MT5',
        paragraphs: ['ทำตามลำดับนี้ทีละขั้น และตรวจสอบทุกรายละเอียดก่อนกดยืนยัน'],
        bullets: [],
        steps: [
          {
            title: 'ขั้นตอนที่ 1 เปิด MT5',
            description: 'ล็อกอินเข้าแพลตฟอร์มและรอให้ราคาเริ่มอัปเดตก่อนเริ่มใช้งาน',
            image:
              'https://readdy.ai/api/search-image?query=Abstract%20minimal%20trading%20platform%20dashboard%20teal%20panels%20warm%20orange%20accent%20on%20light%20background%20editorial%20flat%20ui%20mockup%20no%20text%20no%20people&width=900&height=560&seq=mt5order-step-open-01&orientation=landscape',
          },
          {
            title: 'ขั้นตอนที่ 2 เลือกคู่เงิน',
            description: 'เลือกคู่เงินจาก Market Watch แล้วเปิดหน้าต่าง New Order',
            image:
              'https://readdy.ai/api/search-image?query=Abstract%20minimal%20market%20watch%20panel%20teal%20currency%20rows%20warm%20orange%20selection%20light%20background%20editorial%20flat%20ui%20mockup%20no%20text&width=900&height=560&seq=mt5order-step-pair-01&orientation=landscape',
          },
          {
            title: 'ขั้นตอนที่ 3 กำหนดขนาด Lot',
            description: 'ใส่ค่า Volume ให้สอดคล้องกับความเสี่ยงที่คำนวณไว้ล่วงหน้า',
            image:
              'https://readdy.ai/api/search-image?query=Abstract%20minimal%20volume%20field%20panel%20teal%20input%20warm%20orange%20accent%20on%20light%20background%20editorial%20flat%20ui%20mockup%20no%20text%20no%20people&width=900&height=560&seq=mt5order-step-lot-01&orientation=landscape',
          },
          {
            title: 'ขั้นตอนที่ 4 ตั้ง Stop Loss และ Take Profit',
            description: 'กรอกจุดตัดขาดทุนและจุดทำกำไรก่อนยืนยันคำสั่ง',
            image:
              'https://readdy.ai/api/search-image?query=Abstract%20minimal%20stop%20loss%20take%20profit%20fields%20teal%20warm%20orange%20labels%20on%20light%20background%20editorial%20flat%20ui%20mockup%20no%20text&width=900&height=560&seq=mt5order-step-sltp-01&orientation=landscape',
          },
          {
            title: 'ขั้นตอนที่ 5 ยืนยันคำสั่งซื้อขาย',
            description: 'ตรวจสอบรายละเอียดทั้งหมดแล้วกดยืนยัน ออเดอร์จะไปปรากฏในแท็บ Trade',
            image:
              'https://readdy.ai/api/search-image?query=Abstract%20minimal%20confirmation%20dialog%20teal%20checkmark%20warm%20orange%20accent%20on%20light%20background%20editorial%20flat%20ui%20mockup%20no%20text&width=900&height=560&seq=mt5order-step-confirm-01&orientation=landscape',
          },
        ],
      },
      {
        id: 'checklist',
        heading: 'เช็กลิสต์ก่อนกดยืนยัน',
        paragraphs: ['ก่อนยืนยันทุกครั้ง ควรตรวจสอบรายการต่อไปนี้ให้ครบถ้วน'],
        bullets: [
          'คู่เงินและทิศทางถูกต้อง',
          'ขนาดล็อตตรงกับความเสี่ยงที่คำนวณไว้',
          'มี Stop Loss และ Take Profit ครบ',
          'Spread อยู่ในระดับที่ยอมรับได้',
        ],
        steps: [],
      },
    ],
    faqs: [
      {
        q: 'เปิดออเดอร์บนมือถือได้ไหม',
        a: 'ได้ แอป MT5 บนมือถือเปิดออเดอร์และตั้ง Stop Loss ได้เหมือนบนคอมพิวเตอร์',
        a2: 'ข้อจำกัดที่ควรรู้คือการปิดออเดอร์บางส่วนทำได้แต่ต้องกดหลายขั้น และการลากเส้นแนวรับแนวต้านบนจอเล็กจะคลาดเคลื่อนง่ายมาก แนะนำให้ตั้ง Stop Loss ทันทีหลังเปิดออเดอร์ทุกครั้ง แล้วค่อยกลับไปจัดการบนคอมพิวเตอร์',
      },
      {
        q: 'กดยืนยันแล้วออเดอร์ไม่ขึ้นทำไม',
        a: 'อาจเกิดจากราคาเปลี่ยนไปแล้ว หรือ Spread กว้างเกินไป ลองตรวจสอบข้อความแจ้งเตือนในหน้าต่าง Journal',
        a2: 'สาเหตุที่พบบ่อยที่สุดสามข้อคือ ราคาเคลื่อนไปเกินระยะที่ตั้งไว้ (Requote) Spread กว้างเกินค่าที่อนุญาต หรือขนาด Lot ผิดหน่วยเพราะลืมว่า 0.01 คือ Lot ไม่ใช่ 1 Lot ให้เปิดแท็บ Journal ในหน้าต่าง Terminal ข้อความแจ้งเตือนจะบอกสาเหตุตรง ๆ',
      },
    ],
    related: ['mt5-guide', 'how-to-place-order', 'stop-loss-take-profit'],
  },
];